import clsx from "clsx";
import { rgbaObjectToString } from "../../helpers/utils";
import {
  CATEGORIES_DEFAULT_BG_COLOR,
  CATEGORIES_DEFAULT_TEXT_COLOR,
  ICON_SIZES,
} from "../../helpers/constants";
import { MdCreditCard } from "react-icons/md";
import useMobile from "../../hooks/useMobile";

interface IPageSubtitleAccount {
  name?: string;
  settings?: {
    color?: {
      r: string;
      g: string;
      b: string;
      a: string;
    };
    bg?: {
      r: string;
      g: string;
      b: string;
      a: string;
    };
  };
}

const PageSubtitleAccount: React.FC<IPageSubtitleAccount> = ({
  name,
  settings,
}) => {
  const { isMobile } = useMobile();
  const color = rgbaObjectToString(
    settings?.color || CATEGORIES_DEFAULT_TEXT_COLOR
  );
  const background = rgbaObjectToString(
    settings?.bg || CATEGORIES_DEFAULT_BG_COLOR
  );

  return (
    <div
      className={clsx([
        "md:rounded-full",
        "md:px-2",
        "flex",
        "flex-row",
        "items-center",
        "gap-1",
        "text-sm",
      ])}
      style={isMobile ? {} : { color, background }}
    >
      <MdCreditCard size={isMobile ? ICON_SIZES.XS : ICON_SIZES.SM} />
      {name}
    </div>
  );
};

export default PageSubtitleAccount;
